<template v-if="isLoggedIn">
    <div class="container page">

        <div class="pgrecentrecognition">
            <div class="title">RECENT RECOGNITION</div>
            <div class="row header">
                <div class="col-sm-2"></div>
                <div class="col-sm-3">Name</div>
                <div class="col-sm-3">Cluster / Division</div>
                <div class="col-sm-4"></div>
            </div>
            <div class="ruleheader"></div>
            <div v-for="r in report" :key="r._rowNum">
                <div class="row">
                    <div class="col-sm-2 text-center"><img class="w-100" :src="('/profilepic/' + r.picId)" /></div>
                    <div class="col-sm-3 membername">{{ r.memberName }}</div>
                    <div class="col-sm-3 country">{{ r.division }}</div>
                    <div class="col-sm-4 buttons text-center">
                        <!--<button v-if="r.interest1" v-on:click="onLinkOut('/gettoknow',r.memberId)" class="btn-sm btn btn-primary mr-1">Get to know</button>-->
                        <button v-on:click="onLinkOut('/recognise',r.memberId)" class="btn-sm btn btn-primary mr-1">Shout out</button>
                        <button v-if="isManager" v-on:click="onLinkOut('/reward',r.memberId)" class="btn-sm btn btn-primary">Recognise</button>
                    </div>
                </div>
                <div class="ruledata"></div>
            </div>
            <div v-if="isLoading"><i>Loading...</i></div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import axios from 'axios'
    import sjData from '@/sjUtilData'


    export default {
		name: 'RecentRecognition',
        data() {
            return {
               
                report: [],
                isLoading: false
            }
        },
        computed: {
            member() {
                return this.$store.state.memberStore.member
            },
			isManager() {
				return this.$store.state.memberStore.member.isManager
			},

            isLoggedIn() {
                return this.$store.state.isLoggedIn
            },
        },

        created() {
            this.loadReport();
        },
        mounted() {
            //axios.post('/api/member/memberget', {})
            //	.then(({ data }) => {
            //		//this.roles = data.roles;
            //		//this.noms = new sjData(data.noms).data;
            //		//this.displayPart = 1;
            //	})
            //	.catch((error) => {
            //		if (error) {
            //			this.msgBox(error.response.data.message);
            //		}
            //	})
        },
		watch: {
			
		},

        methods: {
            loadReport() {
                this.isLoading = true;
                this.report = [];
				axios.post('/api/site/getrecentrecognition', {  })
                    .then(({ data }) => {
						this.isLoading = false;
                        this.report = new sjData(data.report).data;
                    })
                    .catch((error) => {
						this.isLoading = false;
                        if (error) {
                            this.msgBox(error.response.data.message);
                        }
                    })
            },


            //*** formStatusUpdate - used to display form errors.
            //Ensure this.form contains the list of fields.
            //Call  formStatusUpdate(true) to initialise/clear the form errors.
            //formObject is the object that contains the following objects:  .form, .formState, .formErrors
            formSetState(formObj, resetState, resetForm) {
                if (typeof resetState === 'undefined') resetState = false;
                if (typeof resetForm === 'undefined') resetForm = false;
                if (typeof formObj.init === 'undefined') formObj.init = { ...formObj.form }; //Initialise .formInit object to be a copy of .form object.
                if (typeof formObj.errors === 'undefined') this.$set(formObj, 'errors', {}); //use this.$set  to make errors object reactive
                if (typeof formObj.state === 'undefined') this.$set(formObj, 'state', {});   //use this.$set  to make state object reactive

                if (resetState || resetForm) {
                    if (resetForm) formObj.form = { ...formObj.init }; //copy .init to .form

                    formObj.errors = {}; //reset formErrors object
                    formObj.state = {};
                }

                //update formState
                var fields = Object.getOwnPropertyNames(formObj.form);
                for (let i = 0; i < fields.length; i++) {
                    let field = fields[i];
                    if (resetState) {
                        formObj.state[field] = null;
                    } else if (typeof formObj.errors[field] === 'undefined' || formObj.errors[field] === '') {
                        formObj.state[field] = true;
                    } else {
                        formObj.state[field] = false;
                    }
                }
            },

            onLinkOut(whereto, data, what) {
                if (typeof what === 'undefined' || what == '') what = 'tloid';
				sessionStorage.setItem(what, data);//tloid - temp link out id;
				this.$router.push(whereto)
			},

            msgBox(msg, title) {
                this.$bvModal.msgBoxOk(msg, { title: typeof title === 'undefined' ? 'Please note:' : title, centered: true })
            }


        }

    }
</script>
